import { render, staticRenderFns } from "./OffersRowComponent.vue?vue&type=template&id=2b20e5b7"
import script from "./OffersRowComponent.vue?vue&type=script&lang=js"
export * from "./OffersRowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports